import { Box, Divider, Link, List, ListItem, Paper, Stack, Typography } from '@mui/material';

import FooterPage from './footerPage';
import HelloSection from 'src/components/helloSection/helloSection';
import NavBar from 'src/components/heroSection/navBar';
import React from 'react';
import { content } from 'src/common/lang/en-US';
import { privacyPolicyData } from 'src/resources/data/privacyPolicyData';

type Content = {
    items: string[];
    description?: string;
    title?: string;
};

type Section = {
    id: string;
    title: string;
    introduction: string;
    link?: string;
    value?: string;
    method?: string;
    content: Content[];
};

const PrivacyPolicy: React.FC = () => {
    return (
        <Stack>
            <NavBar />
            <HelloSection />
            <Box bgcolor="white" color="text.black" p={2}>
                <Paper
                    elevation={2}
                    sx={{
                        backgroundColor: 'text.disabled',
                        borderRadius: 2,
                        color: 'text.black',
                        p: { md: 7, xs: 3 },
                    }}
                >
                    <Typography gutterBottom variant="h2">
                        {content.privacyPolicy.header}
                    </Typography>
                    <Typography color="grey.400" gutterBottom variant="h4_Thin">
                        {content.privacyPolicy.lastUpdated}: {privacyPolicyData.lastUpdated}
                    </Typography>
                    <Divider sx={{ my: 3 }} />
                    {privacyPolicyData.sections.map((section: Section, index: number) => (
                        <Box key={section.id} sx={{ my: 3 }}>
                            <Typography mb={2} variant="h3">
                                {index + 1}. {section.title}
                            </Typography>
                            <Typography color="grey.500" variant="caption1">
                                {section.introduction}
                            </Typography>
                            {section.id === 'contact-us' && (
                                <>
                                    <Typography my={1} variant="body1">
                                        {section.method}
                                        {' : '}
                                        <Link
                                            color="secondary.main"
                                            href={section.link}
                                            rel="noopener noreferrer"
                                            target="_blank"
                                        >
                                            {section.value}
                                        </Link>
                                    </Typography>
                                    <Typography color="grey.500" variant="caption1">
                                        {section?.content[0].items[0]}
                                    </Typography>
                                </>
                            )}
                            {section.id !== 'contact-us' &&
                                section?.content?.map((item, idx: number) => (
                                    <Box key={`${section.id}-content-${idx}`} sx={{ my: 2 }}>
                                        {item?.title && (
                                            <Typography mb={2} variant="h4">
                                                {item.title}
                                            </Typography>
                                        )}
                                        {item?.description && (
                                            <Typography color="grey.500" variant="caption1">
                                                {item.description}
                                            </Typography>
                                        )}
                                        <List dense>
                                            {item.items?.map((listItem: string, index: number) => (
                                                <ListItem key={'content-item' + index}>
                                                    <Typography color="grey.500" variant="caption2_Thin">
                                                        {listItem}
                                                    </Typography>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                ))}
                            <Divider sx={{ my: 3 }} />
                        </Box>
                    ))}
                </Paper>
            </Box>
            <FooterPage />
        </Stack>
    );
};

export default PrivacyPolicy;
